<template>
  <div>
    <dashboard-header :text='$t("sosType.caption")'/>
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pt-10 px-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :add="isCreate ? addItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :on-delete-content="onDeleteContent"
          :placeholder="$t('sosType.searchPlaceholder')"
      >
        <template v-slot:item.colorName="{ item }">
          <div class="d-flex align-center">
            <img :src="require('@/assets/images/sos-type-' + (item.data.color || 'blue') + '.png')" width="24" height="24" class="me-2" />
            {{ item.colorName }}
          </div>
        </template>
      </d-table>

    </v-card>
  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";
import { PERMISSIONS } from "../../config/permissions";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      // removed static permissions - moved to computed
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    // Permission computed properties
    isCreate() {
      return this.hasPermission(PERMISSIONS.SOS_TYPE_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.SOS_TYPE_UPDATE);
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.SOS_TYPE_DELETE);
    },
    fields() {
      return [
        {value: "displayName", text: this.$t("sosType.name")},
        {value: "colorName", text: this.$t("sosType.color")},
        // {value: "nameEng", text: this.$t("sosType.nameEng")},
        {value: "sosTypeNumberSchedules", text: this.$t("ui.sosTypeNumberSchedules"), sortable: false},
        {value: this.isEdit || this.isDelete ? "actions" : null, sortable: false}
      ].filter(field => field.value !== null);
    },
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) return
      this.optionParams = optionParams
      
      // Map displayName sort field to 'name' for backend API
      const apiParams = { ...optionParams }
      if (apiParams.sortBy === 'displayName') {
        apiParams.sortBy = 'name'
      }
      
      let res = await this.get(API2.SOS_TYPE, apiParams)
      if (!res) return
      this.totalRows = res.total
      this.items = res.data.map(value => {
        return {
          data: {...value, idDetail: value.sosTypeId},
          name: value.name,
          displayName: value.name,
          colorName: value.color ? this.$t(`colors.${value.color}`) : this.$t('colors.blue'),
          // nameEng: value.nameEng,
          sosTypeNumberSchedules: value.sosCaseCount || 0
        };
      });
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onItemTableClick(item) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.SOS_TYPE_VIEW, 'Bạn không có quyền xem chi tiết loại SOS')) {
        return;
      }
      this.openTab(1, item)
    },
    onDeleteContent() {
      return this.$t("ui.confirmDataDelSosType")
    },
    async deleteItem(item) {
      let res = await this.delete(API2.SOS_TYPE, {path: item.data.sosTypeId})
      if (res) {
        this.showToast("success", i18n.t("base.notification"), `${i18n.t("base.deleteSuccessful")}`)
        this.getItems(this.optionParams);
      }
    }
  }
};
</script>

<style></style>
